/* istanbul ignore file */
const partsActionTypes = {
  RECEIVE_PARTS: "receive-parts",
  PARTS_LOADING: "parts-loading",
  PARTS_ERROR: "parts-error",
}

const authActionTypes = {
  REMEMBER_DEVICE: "remember-device",
  SKIP_REMEMBER_DEVICE: "skip-remember-device",
  REMEMBER_USER: "remember-user",
  SHOW_SIGNUP: "show-signup",
  RECEIVE_SIGNUP_STATUS: "receive-signup-status",
  RECEIVE_AUTH: "receive-auth",
  LOGOUT: "logout",
  AUTH_LOADING: "auth-loading",
  AUTH_ERROR: "auth-error",
  INIT: "init",
  MFA_SENT: "mfa-sent",
}

const protocolsActionTypes = {
  SEARCH_PROTOCOLS: "search-protocols",
  RECEIVE_PROTOCOLS: "receive-protocols",
  PROTOCOLS_ERROR: "protocols-error",
}

const sortActionTypes = {
  SET_SORT: "set-sort",
}

const siteSettingsActionTypes = {
  SEARCH_SITE_SETTINGS: "search-site-settings",
  RECEIVE_SITE_SETTINGS: "receive-site-settings",
  SITE_SETIINGS_ERROR: "site-settings-error",
}

const pgpOptionsActionTypes = {
  SEARCH_PGP_OPTIONS: "search-pgp-options",
  RECEIVE_PGP_OPTIONS: "receive-pgp-options",
  PGP_OPTIONS_ERROR: "pgp-options-error",
}

const feedbackActionTypes = {
  SEARCH_FEEDBACKS: "search-feedbacks",
  RECEIVE_FEEDBACKS: "receive-feedbacks",
  FEEDBACKS_ERROR: "feedbacks-error",
}

const coverageActionTypes = {
  SEARCH_COVERAGE_MAKES: "search-coverage-makes",
  RECEIVE_COVERAGE_MAKES: "receive-coverage-makes",
  COVERAGE_MAKES_ERROR: "coverage-makes-error",

  SEARCH_COVERAGE_MODELS: "search-coverage-models",
  RECEIVE_COVERAGE_MODELS: "receive-coverage-models",
  COVERAGE_MODELS_ERROR: "coverage-models-error",
}

export {
  authActionTypes,
  coverageActionTypes,
  feedbackActionTypes,
  partsActionTypes,
  pgpOptionsActionTypes,
  protocolsActionTypes,
  siteSettingsActionTypes,
  sortActionTypes,
}
